import React, { useEffect } from 'react';
import { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import CertificateGenerator from "./components/CertificateGenerator";
import HowItWorks from "./components/HowItWorks";
import FAQSection from "./components/FAQSection";
import BenefitsSection from "./components/BenefitsSection";
import SEOArticle from "./components/SEOArticle";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import BlogList from "./components/BlogList";
import BlogPost from "./components/BlogPost";
import GovtGuidesList from "./components/GovtGuidesList";
import GovtGuidePost from "./components/GovtGuidePost";
import ResourcesPreview from "./components/ResourcesPreview";

const ScrollToHash = () => {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 50);
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [hash, pathname]);
  return null;
};

const Home = () => {
  const generatorRef = useRef(null);

  const scrollToGenerator = () => {
    generatorRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection onScrollToGenerator={scrollToGenerator} />

      <div ref={generatorRef} id="generator" className="scroll-mt-20">
        <CertificateGenerator />
      </div>

      <HowItWorks />
      <BenefitsSection />
      <ResourcesPreview />
      <FAQSection />
      <SEOArticle />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/govt-guides" element={<GovtGuidesList />} />
          <Route path="/govt-guides/:slug" element={<GovtGuidePost />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
